module.exports = __webpack_public_path__ + "img/gemp.05c53b2c.png";